import { Switch as SwitchUI } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Wrapper } from './Switch.style';

export type SwitchProps = {
  param: Json;
  onChange: (value: boolean) => void;
  onSet: (value: boolean) => void;
};

export function Switch(props: SwitchProps) {
  const { param } = props;
  const { value } = param;
  const [val, setVal] = useState(value);

  useEffect(() => {
    setVal(value);
  }, [value]);

  function onChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const value = ev.target.checked;
    setVal(ev.target.checked);
    props.onChange(value);
    props.onSet(value);
  }

  return (
    <Wrapper className='Switch-wrapper' data-testid='Switch-wrapper'>
      <SwitchUI checked={val} onChange={onChange} />
    </Wrapper>
  );
}

export default Switch;
